module.exports = __webpack_public_path__ + "img/done.png";